import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PortalArticlesComponent} from "./components/portal-articles/portal-articles.component";
import {PortalAnnouncementsComponent} from "./components/portal-announcements/portal-announcements.component";
import {PortalSearchModule} from "./components/portal-search/portal-search.module";
import {RouterModule} from "@angular/router";
import {SharedModule} from "../../shared/shared.module";
import {DialogAllModule} from "@syncfusion/ej2-angular-popups";
import {ListBoxAllModule} from "@syncfusion/ej2-angular-dropdowns";
import {ListViewAllModule} from "@syncfusion/ej2-angular-lists";



@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    PortalSearchModule,
    DialogAllModule,
    ListBoxAllModule,
    ListViewAllModule
  ],
  declarations: [
    PortalArticlesComponent,
    PortalAnnouncementsComponent,
  ],
  exports: [
    PortalArticlesComponent,
    PortalAnnouncementsComponent
  ]
})
export class PortalPageModule { }
